import { render, staticRenderFns } from "./pay-dialog-iframe.vue?vue&type=template&id=64efea2e&scoped=true&"
import script from "./pay-dialog-iframe.vue?vue&type=script&lang=js&"
export * from "./pay-dialog-iframe.vue?vue&type=script&lang=js&"
import style0 from "./pay-dialog-iframe.vue?vue&type=style&index=0&id=64efea2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64efea2e",
  null
  
)

export default component.exports